import React, {Dispatch, FC, SetStateAction, useEffect} from 'react';
import {message} from "antd";
import {useAppDispatch, useAppSelector} from "../../../../store/store";
import {clearDeclinePlane, declinePlane, getPlaneApprovalList} from "../../../../store/reducers/fleetReducer/fleetReducer";
import {defineMessages, useIntl} from "react-intl";
import {CommonButtonMessages} from "../../../../intl/commonMessages/CommonButtonMessages";
import {CustomModal} from "../../../../components/UI/AntCustom/CustomModal";
import {IPlane} from "../../../../store/reducers/fleetReducer/fleetReducerTypes";
import {InitialPage} from "../../../../utils/constans/pagination/pagination";

const PlaneDeclineModalMessages = defineMessages({
  declineTitle: {
    id: "planeDeclineModal.declineTitle",
    defaultMessage: "Decline aircraft registration",
  },
  declineDescription: {
    id: "planeDeclineModal.declineDescription",
    defaultMessage: "Are you sure you want to decline aircraft registration?",
  },
  declineSuccess: {
    id: "planeDeclineModal.declineSuccess",
    defaultMessage: "Aircraft has been declined.",
  },
})

interface IPlaneDeclineModal {
  plane: IPlane;
  isVisible: boolean;
  setIsVisible: Dispatch<SetStateAction<boolean>>;
  isPending: boolean;
}

export const PlaneDeclineModal: FC<IPlaneDeclineModal> = ({plane, isVisible, setIsVisible, isPending}) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();

  const {
    isLoading,
    isSuccess,
    errorMessage,
  } = useAppSelector(state => state.fleet.decline);

  useEffect(() => {
    if (!isLoading) {
      if (isSuccess) {
        message.success(intl.formatMessage(PlaneDeclineModalMessages.declineSuccess));
        setIsVisible(false);
        // Обновляем список после успешного отклонения
        dispatch(getPlaneApprovalList({
          isPending: isPending,
          page: InitialPage,
        }));
      }
      if (errorMessage) {
        message.error(errorMessage);
      }
    }

    return () => {
      dispatch(clearDeclinePlane());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, errorMessage, isLoading])

  const handleOk = () => {
    dispatch(declinePlane({
      planeId: plane.id,
    }));
  };

  return (
    <CustomModal
      open={isVisible}
      title={intl.formatMessage(PlaneDeclineModalMessages.declineTitle)}
      centered
      okButtonProps={{loading: isLoading, danger: true, type: "primary"}}
      okText={intl.formatMessage(CommonButtonMessages.decline)}
      cancelText={intl.formatMessage(CommonButtonMessages.cancel)}
      onCancel={() => setIsVisible(false)}
      onOk={handleOk}
      afterClose={() => {
        dispatch(clearDeclinePlane());
      }}
      width={500}
    >
      <p>{intl.formatMessage(PlaneDeclineModalMessages.declineDescription)}</p>
      <p><strong>{plane.registrationNumber}</strong></p>
    </CustomModal>
  );
};

